class HeroVideo extends HTMLElement {
  connectedCallback() {
    const video = this.querySelector('video');
    if (!video) return;

    const isDesktop = window.matchMedia('(min-width: 768px)').matches;
    const template = this.querySelector(`template[data-viewport="${isDesktop ? 'desktop' : 'mobile'}"]`);
    if (!template) return;
    video.appendChild(template.content.cloneNode(true));
    video.load();

    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.loop = true;

    video.addEventListener('ended', () => {
      video.currentTime = 0;
      video.play().catch(() => {});
    });

    const reveal = () => video.classList.replace('opacity-0', 'opacity-100');

    const tryPlay = () => {
      const result = video.play();
      if (result && typeof result.then === 'function') {
        result.then(reveal).catch(() => {
          video.controls = false;
          document.addEventListener('touchstart', () => video.play().then(reveal).catch(() => {}), { once: true });
        });
      } else {
        reveal();
      }
    };

    if (video.readyState >= 2) {
      tryPlay();
    } else {
      video.addEventListener('loadeddata', tryPlay, { once: true });
    }
  }
}

customElements.define('hero-video', HeroVideo);
